// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"b7t4j"};